import masterResearch from "./images/masterResearch.jpg";
import nitRoukela from "./images/nitRoukela.jpg";
import primeMinister from "./images/primeMinister.jpg";
import vcBitsPilani from "./images/vcBitsPilani.jpg";
import lordsInstitute from "./images/lordsInstitute.jpg";
import annamaliaInstitue from "./images/annamaliaInstitue.jpg";
import iucee from "./images/iucee.jpg";
import iitBombay from "./images/iitBombay.jpg";
import dareToDream from "./images/dareToDream.jpg";
import iitDelhi from "./images/iitDelhi.jpg";
import tedx from "./images/tedx.jpg";
import vbit from "./images/vbit.jpg";
import fdpConducted from "./images/fdpConducted.jpg";
import esdaWinner from "./images/esdaWinner.jpg";
import nedoFunded from "./images/nedoFunded.jpg";

const cards = [
  {
    imgUrl: masterResearch,
    desc: "Awards Won for Masters Research",
  },

  {
    imgUrl: nitRoukela,
    desc: "Best Paper Award from NIT Rourkela",
  },
  {
    imgUrl: primeMinister,
    desc: "Birthday wish from the honorable Prime Minister of India",
  },
  {
    imgUrl: vcBitsPilani,
    desc: "Book release by the VC_BITS Pilani",
  },
  {
    imgUrl: lordsInstitute,
    desc: "Delivered a Keynote Address at Lords Institute Hyderabad",
  },
  {
    imgUrl: annamaliaInstitue,
    desc: "Delivered a plenary talk at Annamalai University",
  },
  {
    imgUrl: iucee,
  },
  {
    imgUrl: iitBombay,
  },
  {
    imgUrl: dareToDream,
  },
  {
    imgUrl: iitDelhi,
  },
  {
    imgUrl: tedx,
  },
  {
    imgUrl: vbit,
  },
  {
    imgUrl: fdpConducted,
  },
  {
    imgUrl: esdaWinner,
  },
  {
    imgUrl: nedoFunded,
  },
];

export default cards;
